import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-625b0ba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "shadow-mask"
}
const _hoisted_2 = ["open"]
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "btn group" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertDialog',
  props: {
  hideCloseButton: {
    type: Boolean,
    default: false,
  },
},
  emits: ['close'],
  setup(__props, { expose: __expose, emit }) {





const isVisible = ref(false);

const open = () => {
  isVisible.value = true;
};

const close = () => {
  isVisible.value = false;
  emit('close');
};

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("dialog", {
          open: isVisible.value,
          onClose: close
        }, [
          _createElementVNode("header", null, [
            _renderSlot(_ctx.$slots, "title"),
            _createElementVNode("button", {
              class: "btn close-x",
              onClick: close
            }, "X")
          ]),
          _createElementVNode("section", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("footer", _hoisted_4, [
            (!__props.hideCloseButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn close",
                  onClick: close
                }, "Close"))
              : _createCommentVNode("", true)
          ])
        ], 40, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})